<div class="bk-dialog bk-dialog__event">
	<button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>

	<h4 mat-dialog-title>
		<ng-container *ngIf="data && data.lot"
			class="bk-modal__header-title">
			{{'Edit' | translate }} {{'Planting Area' | translate }}
		</ng-container>
		<ng-container *ngIf="!data || !data.lot"
			class="bk-modal__header-title">
			{{'Add' | translate }} {{'Planting Area' | translate }}
		</ng-container>
	</h4>

	<ranch-lot-form
		[lot]="data && data.lot ? data.lot : null"
		[ranchCoordinates]="data ? data.ranchCoordinates : null"
		[isRanchCreateProcess]="true"
		(onCancel)="close()"
		(onHide)="hide()"
		(onShow)="show()"
		(onSubmit)="submit($event)">
	</ranch-lot-form>
</div>
